import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";

function Sample872699() {
  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="baby-v1" sampleId="872699" />
        <span> - </span>
        <SampleQuote text="ESCALUS" targetIdx={5} />
      </h4>
      <p>
        Feature <FeatureAnchor modelId="baby-v1" sampleId="872699" featureKey="0.2.6136" compact />{" "}
        fires upon the “U” in “ESCALUS” and builds upon the patterns of two upstream features,&nbsp;
        <FeatureAnchor modelId="baby-v1" sampleId="872699" featureKey="5.1.1625" compact />{" "}
        and&nbsp;
        <FeatureAnchor modelId="baby-v1" sampleId="872699" featureKey="0.1.693" compact />
        .&nbsp; Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="872699" featureKey="5.1.1625" compact />{" "}
        activates for character names that have an “E” in the first or second letter. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="872699" featureKey="0.1.693" compact /> activates
        on the “U” in character names that contain both a “C” and an “L”. Together, these upstream
        dependencies allow downstreams features to accurately fire when in the context of the
        character’s name as used in a title.
      </p>
      <figure>
        <figcaption>Circuit Detecting the &ldquo;U&rdquo; in &ldquo;ESCALUS&rdquo;</figcaption>
        <ul className="tree">
          <li>
            <span className="node">
              <span className="feature">
                <FeatureAnchor
                  modelId="baby-v1"
                  sampleId="872699"
                  featureKey="0.2.6136"
                  compact={true}
                />
              </span>
              <span className="description">
                <SampleQuote text="ESCALUS" targetIdx={5} quotes={false} ellipsis={false} />
              </span>
              <span className="spacer" />
            </span>
            <ul>
              <li>
                <span className="node">
                  <span className="feature">
                    <FeatureAnchor
                      modelId="baby-v1"
                      sampleId="872699"
                      featureKey="5.1.1625"
                      compact={true}
                    />
                  </span>
                  <span className="description">
                    <SampleQuote text="MENENIUS" targetIdx={1} quotes={false} ellipsis={false} />
                    <SampleQuote text="HERMIONE" targetIdx={1} quotes={false} ellipsis={false} />
                    <SampleQuote text="ESCALUS" targetIdx={0} quotes={false} ellipsis={false} />
                  </span>
                </span>
                <ul>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="872699"
                          featureKey="6.0.6027"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="⏎" targetIdx={0} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="872699"
                          featureKey="5.0.3922"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="E" targetIdx={0} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                </ul>
              </li>
              <li>
                <span className="node">
                  <span className="feature">
                    <FeatureAnchor
                      modelId="baby-v1"
                      sampleId="872699"
                      featureKey="0.1.693"
                      compact={true}
                    />
                  </span>
                  <span className="description">
                    <SampleQuote text="CORIOLANUS" targetIdx={8} quotes={false} ellipsis={false} />
                    <SampleQuote text="ESCALUS" targetIdx={5} quotes={false} ellipsis={false} />
                    <SampleQuote text="CLAUDIO" targetIdx={3} quotes={false} ellipsis={false} />
                  </span>
                </span>
                <ul>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="872699"
                          featureKey="3.0.5934"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="C" targetIdx={0} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="872699"
                          featureKey="1.0.77"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="L" targetIdx={0} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="baby-v1"
                          sampleId="872699"
                          featureKey="0.0.3201"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote text="U" targetIdx={0} quotes={false} ellipsis={false} />
                      </span>
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </figure>
    </section>
  );
}

export { Sample872699 };
